import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    if (window.location.hash) {
      this.highlightElement()
    }

    this.hashChangeHandler = () => this.highlightElement()
    window.addEventListener('hashchange', this.hashChangeHandler)
  }

  disconnect () {
    window.removeEventListener('hashchange', this.hashChangeHandler)
  }

  highlightElement () {
    const hash = window.location.hash
    if (!hash) return

    document.querySelectorAll('.highlighted-item').forEach(el => {
      el.classList.remove('highlighted-item')
    })

    const element = document.querySelector(hash)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      element.classList.add('highlighted-item')

      setTimeout(() => {
        element.classList.remove('highlighted-item')
      }, 3000)
    }
  }
}
